// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-textarea__inner[data-v-5db3779e], .el-input__inner[data-v-5db3779e] {\n  font-size: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
